import createGraphqlClient from "@/utils/apollo";

export const fragments = {
	Request: `
		fragment Request on CmrequestRequest {
			id
			code
			data
			is_owner
			has_document
			display_name
			req_type_id
			req_status_id
			user_option {
				color
			}
			reqstatus{
				id
				name
				status
				controls {
					id
					title
					control
					children
					attributes
					is_optional
					enable
					description {
						value
						enable
						position
					}
				}
				pending_input
				approverFillInfo
				color
			}
			logs {
				id
				updated_at
				approved_by {
				  	name
				}
			}
			relations{
				id
				type
				display
			}
			created_at
			updated_at
			is_done
			is_cancel
			is_reject
			is_dynamic
			reject_reason
			cancel_reason
			can_update
			can_fill_extra_info
			can_cancel
			can_export
			request_reason
			can_edit
			attachs {
				id
				file_name
				file_size
				path
				extension
			}
			reqtype {
				id
				name
				disable
				controls {
					id
					title
					control
					children
					attributes
					is_optional
					enable
					description {
						value
						enable
						position
					}
				}
				statuses {
					id
					name
					sort_order
					data
					description
					status
					is_active
					color
					pending_input
					logs {
						id
						note
						updated_at
						approved_by {
							name
						}
					}
					attachs {
						id
						file_name
						file_size
						path
						extension
					}
					controls {
						id
						title
						control
						children
						attributes
						is_optional
						enable
						description {
							value
							enable
							position
						}
					}
				}
			}
			requester {
				id
				name
				avatar(w: 300, h: 300)
				department {
					id
					name
				}
			}
		}
	`,
	RequestSimpleData: `
		fragment RequestSimpleData on CmrequestRequest {
			id
			code
			is_owner
			req_type_id
			display_name
			user_option {
				color
			}
			reqstatus {
				id
				name
				status
				pending_input
			}
			created_at
			updated_at
			is_done
			is_cancel
			is_reject
			can_update
			can_cancel
			request_reason
			can_edit
			data
			reqtype {
				id
				name
				statuses {
					id
					name
					status
					is_active
					color
				}
				controls {
					id
					title
					control
				}
			}
			requester {
				id
				name
				avatar(w: 300, h: 300)
			}
		}
	`,
	RequestTypeSimpleData: `
		fragment RequestTypeSimpleData on CmrequestRequestType {
			id name type disable
			is_private
			who_can_create{
				id
				type
				name
			}
			document {
				id
				path
				file_name
				extension
			}
			generate_code
			schedule_generate_code

		}
	`,
	RequestType: `
		fragment RequestType on CmrequestRequestType {
			id name type disable
			is_private
			can_update
			can_delete
			document {
				id
				path
				file_name
				extension
			}
			controls {
				id
				title
				control
				children
				attributes
				is_optional
				enable
				description {
					value
					enable
					position
				}
			}
			statistic_expressions {
				id
				name
				expression
				type_object {
					key
					value
				}
			}
			statuses {
				id
				name
				description
				approverFillInfo
				color
				notifications {
					approvers {
						content
						hashtag_content
						relations {
							id
							name
							type
						}
					}
					approve_notifications {
						content
						hashtag_content
						relations {
							id
							name
							type
						}
					}
					reject_notifications {
						content
						hashtag_content
						relations {
							id
							name
							type
						}
					}
				}
				sort_order
				form_type
				controls {
					id
					title
					control
					children
					attributes
					is_optional
					enable
					description {
						value
						enable
						position
					}
				}
			}
		}
	`,
	RequestTypes: `
		fragment RequestTypes on CmrequestRequestTypePagination {
			total
			has_more_pages
			data {
				id name type disable created_at
				is_private
				can_create
				can_update
				can_delete
				document {
					id
					path
					file_name
					extension
				}
				controls {
					id
					title
					control
					children
					attributes
					is_optional
					description {
						value
						enable
						position
					}
				}
				statuses {
					id
					name
					sort_order
					form_type
					controls {
						id
						title
						control
						children
						attributes
						is_optional
						description {
							value
							enable
							position
						}
					}
				}
			}
		}
	`,
	DynamicFormField: `
		fragment DynamicFormField on CmrequestForm {
			id
			title
			control
			children
			attributes
			is_optional
			enable
			description {
				value
				enable
				position
			}
		}
	`,
	RequestStatus: `
		fragment RequestStatus on CmrequestRequestStatus {
			id
			name
			controls {
				id
				title
				control
				children
				attributes
				is_optional
				description {
					value
					enable
					position
				}
			}
			form_type
			description
			approverFillInfo
			color
			notifications {
				approvers {
					content
					hashtag_content
					relations {
						id
						name
						type
					}
				}
				approve_notifications {
					content
					hashtag_content
					relations {
						id
						name
						type
					}
				}
				reject_notifications {
					content
					hashtag_content
					relations {
						id
						name
						type
					}
				}
			}
		}
	`,
	StatisticalExpression: `
		fragment StatisticalExpression on CmrequestStatisticExpression {
			id
			name
			expression
			type_object {
				key
				value
			}
		}
	`,
	RequestByRelations: `
		fragment RequestByRelations on CmrequestRequest {
			id
			reqtype {
				id
				name
			}
			request_reason
			created_at
		}
	`
};

export default createGraphqlClient("cmrequest");
